export default __webpack_public_path__ + "static/media/536.e0685c5c.png";